import { FC, useEffect, useMemo } from 'react';
import { FATCATranslations } from '../../../utils/getFATCATranslations';
import { useFATCAFormState } from '../../../utils/useFATCAFormState';
import { ButtonBase } from '../../../../common';
import { FATCATaxResidencyVerticalEntry } from './subComponents/FATCATaxResidencyVerticalEntry/FATCATaxResidencyVerticalEntry';
import { css } from '@bts-web/utils-style-engine';
import { FilledAdd } from '../../../../common/svgIcons';

const FATCATaxResidencyPrimaryHub: FC<{
  fatcaFormState: ReturnType<typeof useFATCAFormState>;
  translations: FATCATranslations;
}> = ({ fatcaFormState, translations }) => {
  const { fatcaTaxResidencies, onNextStep } = fatcaFormState;

  const {
    fatcaTaxResidencies: fatcaTaxResidenciesEntries,
    addFATCATaxResidency,
  } = fatcaTaxResidencies;

  useEffect(() => {
    if (fatcaTaxResidenciesEntries.length === 0) {
      addFATCATaxResidency();
    }
  }, [addFATCATaxResidency, fatcaTaxResidenciesEntries.length]);

  const { buttonDisabled } = useMemo(() => {
    let buttonDisabled = false;

    if (fatcaTaxResidenciesEntries.length === 0) {
      buttonDisabled = true;
    }

    if (
      fatcaTaxResidenciesEntries.some((entry) => {
        if (!entry.countryValue) {
          return true;
        }

        if (!entry.tinAbsent && !entry.tinCode) {
          return true;
        }

        return false;
      })
    ) {
      buttonDisabled = true;
    }

    return { buttonDisabled };
  }, [fatcaTaxResidenciesEntries]);

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'small',
      })}
    >
      <ul
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'small',
          padding: '0',
          listStyleType: 'none',
        })}
      >
        {fatcaTaxResidencies.fatcaTaxResidencies.map((residency) => (
          <FATCATaxResidencyVerticalEntry
            translations={translations}
            fatcaTaxResidencies={fatcaTaxResidencies}
            key={residency.id}
            id={residency.id}
          />
        ))}
      </ul>
      <ButtonBase
        visual="ghostOutlined"
        size="large"
        fullWidth
        onClick={() => fatcaTaxResidencies.addFATCATaxResidency()}
      >
        {translations.add_another_residency} <FilledAdd name="plus" />
      </ButtonBase>
      <ButtonBase
        onClick={onNextStep}
        disabled={buttonDisabled}
        size="large"
        fullWidth
      >
        {translations.next}
      </ButtonBase>
    </div>
  );
};

export { FATCATaxResidencyPrimaryHub };
